import Loading from "app/storybookComponents/Loading";

export default function PdfDownloadOverlay() {
  return (
    <div className="download-blur-container">
      <div className="download-blur" />
      <div style={{ zIndex: 99990 }}>
        Downloading Report... <Loading />
      </div>
    </div>
  );
}
